import React from 'react'
import moment from 'moment'
import classnames from 'classnames'
import { memoize } from 'lodash'
import Select from './Select'

const getTimes = memoize(() => {
  let times = []
  let hour = 0
  while (hour < 24) {
    const oclock = moment().hour(hour).minute(0)
    const thirty = moment().hour(hour).minute(30)
    times.push({ value: oclock.format('H:mm'), label: oclock.format('LT') })
    times.push({ value: thirty.format('H:mm'), label: thirty.format('LT') })
    hour++
  }
  const final = moment().hour(23).minute(59)
  times.push({ value: final.format('H:mm'), label: final.format('LT') })
  return times
})

const SelectTime = ({ min, max, className, ...rest }) => {
  return (
    <Select {...rest}
      className={classnames('SelectTime', className)}
      options={getTimes()}
    />
  )
}

SelectTime.displayName = 'SelectTime'

export default SelectTime



// WEBPACK FOOTER //
// ./src/lib/form/SelectTime.js